// Motor de reglas dinámicas en el cliente. Espejo de `Forms::RulesEngine` (Ruby)
// para que la evaluación del formulario público coincida con la del servidor.

export const RULE_TYPES = {
  VISIBILITY: 'visibility',
  OPTION_FILTER: 'option_filter',
};

export const OPERATORS = {
  EQUALS: 'equals',
  NOT_EQUALS: 'not_equals',
  ONE_OF: 'one_of',
};

export const ACTIONS = {
  SHOW: 'show',
  HIDE: 'hide',
};

const conditionMet = (rule, values) => {
  const sourceValue = values[rule.source_field];
  switch (rule.operator) {
    case OPERATORS.EQUALS:
      return sourceValue === rule.value;
    case OPERATORS.NOT_EQUALS:
      return sourceValue !== rule.value;
    case OPERATORS.ONE_OF:
      return Array.isArray(rule.value) && rule.value.includes(sourceValue);
    default:
      return false;
  }
};

const visibilityRules = rules =>
  rules.filter(rule => rule.type === RULE_TYPES.VISIBILITY);

const isFieldVisible = (fieldName, rules, values) => {
  const showRules = visibilityRules(rules).filter(
    rule =>
      rule.action === ACTIONS.SHOW && rule.target_fields.includes(fieldName)
  );
  const hideRules = visibilityRules(rules).filter(
    rule =>
      rule.action === ACTIONS.HIDE && rule.target_fields.includes(fieldName)
  );

  let visible =
    showRules.length === 0 ||
    showRules.some(rule => conditionMet(rule, values));
  if (hideRules.some(rule => conditionMet(rule, values))) {
    visible = false;
  }
  return visible;
};

// Nombres de campos que las reglas de visibilidad ocultan para los valores dados.
export const computeHiddenFields = (rules = [], values = {}) => {
  const targets = new Set();
  visibilityRules(rules).forEach(rule => {
    (rule.target_fields || []).forEach(field => targets.add(field));
  });

  return [...targets].filter(field => !isFieldVisible(field, rules, values));
};

// Opciones permitidas para un select objetivo según las reglas de filtrado.
export const allowedOptions = (rules, values, targetField, allOptions = []) => {
  const rule = rules.find(
    item =>
      item.type === RULE_TYPES.OPTION_FILTER &&
      item.target_field === targetField
  );
  if (!rule) {
    return allOptions;
  }

  const sourceValue = values[rule.source_field];
  const mapping = rule.mapping || {};
  if (!Object.prototype.hasOwnProperty.call(mapping, sourceValue)) {
    return allOptions;
  }

  const allowed = mapping[sourceValue] || [];
  return allOptions.filter(option => allowed.includes(option));
};

// Campos objetivo de reglas de filtrado de opciones (para inicializar bindings).
export const optionFilterTargets = (rules = []) =>
  rules
    .filter(rule => rule.type === RULE_TYPES.OPTION_FILTER)
    .map(rule => rule.target_field);
